import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api'; // adjust import path if needed
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Typography
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // <-- ADDED
import { toast } from 'react-toastify';

function AddHolidayPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [holidayDate, setHolidayDate] = useState('');
  const [isActive, setIsActive] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/holidays', {
        name,
        holiday_date: holidayDate,
        is_active: isActive,
      });
      toast.success('Holiday created successfully!');
      navigate('/admin/holidays');
    } catch (error) {
      console.error(error);
      toast.error('Failed to create holiday. Please try again.');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: 'auto', mt: 3 }}>
      {/* Top Bar with Title + Back Button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Typography variant="h6">Create Holiday</Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Holiday Name"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <TextField
          label="Holiday Date"
          type="date"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
          value={holidayDate}
          onChange={(e) => setHolidayDate(e.target.value)}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label="Active"
        />

        <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
          Create Holiday
        </Button>
      </form>
    </Box>
  );
}

export default AddHolidayPage;
